import React from 'react';
import { OriginIcon, IOriginIconProps } from './OriginIcon';

export function createIcon(
  displayName: string,
  path: React.ReactElement<any> | React.ReactElement<any>[]
) {
  // eslint-disable-next-line react/display-name
  return (props: IOriginIconProps) => (
    <OriginIcon name={`${displayName}Icon`} {...props}>
      {path}
    </OriginIcon>
  );
}
